/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Comingsoon1Inputs */

const ja_playdata_pricing_comingsoon1 = /** @type {(inputs: Playdata_Pricing_Comingsoon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近日公開予定`)
};

const en_playdata_pricing_comingsoon1 = /** @type {(inputs: Playdata_Pricing_Comingsoon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Playdata_Pricing_Comingsoon1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_pricing_comingsoon1 = /** @type {((inputs?: Playdata_Pricing_Comingsoon1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Comingsoon1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_comingsoon1(inputs)
	return en_playdata_pricing_comingsoon1(inputs)
});
export { playdata_pricing_comingsoon1 as "playdata_pricing_comingSoon" }